import Component from '@ember/component';
import { computed, getProperties, get } from '@ember/object';
import { service } from '@ember/service';
import { alias, empty } from '@ember/object/computed';

/* attrs
  - field (coaching/individual sectionField)
  - report - the coach report
  - individual - the coach individual record
  - diff - display the difference from previous report val
  - propertyName - property name to display. Default is 'v'
*/
export default Component.extend({
  coachingService: service(),

  field: null,
  report: null,
  individual: null,
  diff: false,
  propertyName: null,

  fieldType: alias('field.t'),

  val: computed('field.id', 'report.id', 'propertyName', 'total', function () {
    let { field, report, coachingService, diff, propertyName } = getProperties(
      this,
      'field',
      'report',
      'coachingService',
      'diff',
      'propertyName',
    );
    if (diff) {
      return this.diffVal;
    } else if (propertyName) {
      return coachingService.getFieldValue(field, report, { propertyName });
    } else {
      return coachingService.getFieldValue(field, report);
    }
  }),

  diffVal: computed(
    'field.id',
    'report.id',
    'diff',
    'propertyName',
    function () {
      let { field, report, propertyName, individual } = getProperties(
        this,
        'field',
        'report',
        'propertyName',
        'individual',
      );
      return this.coachingService.getFieldValueDiff(field, report, individual, {
        propertyName,
      });
    },
  ),

  prevReportTasks: computed('field.id', 'report.id', 'total', function () {
    let { field, fieldType, report, individual, coachingService } =
      getProperties(
        this,
        'field',
        'fieldType',
        'report',
        'individual',
        'coachingService',
      );
    if (fieldType !== 'tasks') {
      return null;
    }
    let sortedReports = get(individual, 'sortedReports').toArray();
    let reportIndex = sortedReports.indexOf(report);
    if (reportIndex === 0) {
      return null;
    }
    let prevReport = sortedReports[reportIndex - 1];
    return coachingService.getFieldValue(field, prevReport);
  }),

  valIsEmpty: empty('val'),
});
